import React from "react";
import { I } from "services/lang/LanguageService";

export interface ISeparatorProps {
  title: string;
}
export default function Separator(props: ISeparatorProps) {
  return <h2 className="text-center">{I(props.title)}</h2>;
}
